import { getMPDataWithoutParams } from 'src/mentor/services'
import { readEmrSyncPayload } from './emrSyncPolicy'

// Fetch for each sync/prime, coalescing concurrent callers only. A previous account's
// policy or an expired cached allow must never override a new Support setting.
let inFlight = null
let inFlightToken = null
export function getEmrSyncConfig() {
  const token = localStorage.getItem('token')
  if (inFlight && inFlightToken === token) return inFlight
  inFlightToken = token
  const request = (async () => {
    const response = await getMPDataWithoutParams('/api/secure/emr/sync-config')
    const config = readEmrSyncPayload(response)
    if (typeof config?.syncEnabled !== 'boolean' || !Array.isArray(config.enabledCollections)) {
      throw new Error('EMR sync policy is unavailable')
    }
    if (localStorage.getItem('token') !== token) throw new Error('Account changed during sync')
    return config
  })()
  inFlight = request
  return request.finally(() => { if (inFlight === request) inFlight = null })
}

export function getEmrSyncAuthorities() {
  try {
    const roles = JSON.parse(localStorage.getItem('authorities'))
    return Array.isArray(roles) ? roles : []
  } catch { return [] }
}
